var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, ElementRef, NgZone, OnChanges, SimpleChanges } from '@angular/core';
import { PrismicService } from '../prismic/prismic.service';
import { GoogleMapsService } from '../google-maps/google-maps.service';
import { Router } from '@angular/router';
import { UiService } from '../ui/ui.service';
import { ProjectService } from '../project/project.service';
import { Subject } from 'rxjs';
var ProjectsMapComponent = /** @class */ (function () {
    function ProjectsMapComponent(elementRef, prismicService, googleMapsService, router, zone, ui, projectService) {
        this.elementRef = elementRef;
        this.prismicService = prismicService;
        this.googleMapsService = googleMapsService;
        this.router = router;
        this.zone = zone;
        this.ui = ui;
        this.projectService = projectService;
        this.draggable = false;
        this.empty = false;
        this.offsetCenter = false;
        this.hasBeenDragged = false;
        this.markers = [];
        this.features = [];
        this.mapLoaded$ = new Subject();
        this.mapIdle$ = new Subject();
        this.loadedItem$ = new Subject();
        this.itemsLoaded$ = new Subject();
    }
    ProjectsMapComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.zone.runOutsideAngular(this.setupMap.bind(this));
                return [2 /*return*/];
            });
        });
    };
    ProjectsMapComponent.prototype.setupMap = function () {
        return __awaiter(this, void 0, void 0, function () {
            var googleMapsPromise, google, map, _a, _b, featureProjectMap, api, projects, filteredProjects, _loop_1, this_1, _i, filteredProjects_1, project;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        googleMapsPromise = this.googleMapsService.promise;
                        return [4 /*yield*/, googleMapsPromise];
                    case 1:
                        google = _c.sent();
                        window.google = google;
                        map = new google.maps.Map(this.elementRef.nativeElement, {
                            center: new google.maps.LatLng(51.25482464949703, 4.580097198486328),
                            zoom: 13,
                            mapTypeId: google.maps.MapTypeId.SATELLITE,
                            // styles: require('./style.json'),
                            streetViewControl: false,
                            disableDefaultUI: true,
                            scrollwheel: false,
                            disableDoubleClickZoom: true,
                            gestureHandling: this.draggable ? 'greedy' : 'none'
                        });
                        this.map = map;
                        this.overlayView = new google.maps.OverlayView();
                        this.overlayView.draw = function () { };
                        this.overlayView.setMap(this.map);
                        google.maps.event.addListener(this.map, 'projection_changed', function () { return _this.handleProjectionChange(); });
                        google.maps.event.addListener(this.map, 'drag', function () { return _this.hasBeenDragged = true; });
                        google.maps.event.addListener(this.map, 'idle', function () {
                            _this.mapIdle$.next();
                            _this.mapIdle$.complete();
                        });
                        _b = (_a = map.data).setStyle;
                        return [4 /*yield*/, this.getMapStyle(this.empty ? 'empty' : 'default')];
                    case 2:
                        _b.apply(_a, [_c.sent()]);
                        this.mapLoaded$.next();
                        this.mapLoaded$.complete();
                        this.bounds = new google.maps.LatLngBounds();
                        featureProjectMap = new Map();
                        return [4 /*yield*/, this.prismicService.api()];
                    case 3:
                        api = _c.sent();
                        return [4 /*yield*/, this.projectService.fetchAll()];
                    case 4:
                        projects = _c.sent();
                        if (this.uids) {
                            filteredProjects = projects.filter(function (p) { return _this.uids.indexOf(p.uid) > -1; });
                        }
                        else {
                            filteredProjects = projects;
                        }
                        _loop_1 = function (project) {
                            this_1.projectService.getGeoJson(project.locationUrl).then(function (geojson) { return __awaiter(_this, void 0, void 0, function () {
                                var geoJsonPointFeature, marker, _a, _b, _c, feature;
                                return __generator(this, function (_d) {
                                    switch (_d.label) {
                                        case 0:
                                            geoJsonPointFeature = geojson.features[0];
                                            if (!(geojson.features.length === 1 && geoJsonPointFeature.geometry.type === 'Point')) return [3 /*break*/, 2];
                                            _b = (_a = google.maps.Marker).bind;
                                            _c = {
                                                map: this.empty ? null : map,
                                                position: new google.maps.LatLng(geoJsonPointFeature.geometry.coordinates[1], geoJsonPointFeature.geometry.coordinates[0])
                                            };
                                            return [4 /*yield*/, this.getIconStyle()];
                                        case 1:
                                            marker = new (_b.apply(_a, [void 0, (_c.icon = _d.sent(),
                                                    _c)]))();
                                            this.addInfoWindowMarker(marker, project);
                                            return [3 /*break*/, 3];
                                        case 2:
                                            feature = map.data.addGeoJson(geojson)[0];
                                            featureProjectMap.set(feature, project);
                                            this.addInfoWindowFeature(feature, project);
                                            _d.label = 3;
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); });
                        };
                        this_1 = this;
                        for (_i = 0, filteredProjects_1 = filteredProjects; _i < filteredProjects_1.length; _i++) {
                            project = filteredProjects_1[_i];
                            _loop_1(project);
                        }
                        this.loadedItem$.complete();
                        this.itemsLoaded$.next();
                        this.itemsLoaded$.complete();
                        return [2 /*return*/];
                }
            });
        });
    };
    ProjectsMapComponent.prototype.addInfoWindowFeature = function (feature, project) {
        var _this = this;
        var topLatLng;
        feature.getGeometry().forEachLatLng(function (latLng) {
            _this.bounds.extend(latLng);
            if (!topLatLng || latLng.lat() > topLatLng.lat())
                topLatLng = latLng;
        });
        this.addInfoWindow(topLatLng, project, false);
        this.features.push(feature);
        this.map.data.addListener('click', function (event) {
            if (event.feature !== feature)
                return;
            _this.zone.run(function () {
                _this.router.navigate(['/projecten', project.uid]);
            });
        });
        this.loadedItem$.next(feature);
    };
    ProjectsMapComponent.prototype.addInfoWindowMarker = function (marker, project) {
        var _this = this;
        this.addInfoWindow(marker.getPosition(), project, true);
        this.markers.push(marker);
        this.bounds.extend(marker.getPosition());
        google.maps.event.addListener(marker, 'click', function () {
            _this.zone.run(function () {
                _this.router.navigate(['/projecten', project.uid]);
            });
        });
        this.loadedItem$.next(marker);
    };
    ProjectsMapComponent.prototype.addInfoWindow = function (latLng, project, point) {
        var _this = this;
        var InfoBox = require('google-maps-infobox');
        var left = project.mapTagSide === 'left';
        var infowindow = new InfoBox({
            content: "\n        <div class=\"infobox-displacer " + (point ? 'infobox-displacer--point' : 'infobox-displacer--polygon') + " " + (left ? 'infobox-displacer--left' : 'infobox-displacer--right') + "\">\n          <div class=\"infobox-pointer\"></div>\n          <div class=\"infobox-content\">\n            <a class=\"infobox-link\" href='/projecten/" + project.uid + "' data-project-id='" + project.uid + "'>\n              <span class=\"infobox-text\">" + project.name + "</span>\n            </a>\n          </div>\n        </div>\n      ",
            closeBoxURL: '',
            closeBoxMargin: 0,
            boxStyle: {
                overflow: 'visible'
            }
        });
        var marker = new google.maps.Marker({
            position: latLng,
            map: this.empty ? null : this.map,
            visible: false
        });
        this.markers.push(marker);
        infowindow.open(this.map, marker);
        google.maps.event.addListener(infowindow, 'domready', function () {
            console.log(project.uid, 'infowindow ready');
            var link = _this.elementRef.nativeElement.querySelector("[data-project-id=" + project.uid + "]");
            link.addEventListener('click', function (event) {
                _this.zone.run(function () {
                    console.log('clicked', project.uid);
                    event.preventDefault();
                    _this.router.navigate(['/projecten', project.uid]);
                });
            });
        });
    };
    ProjectsMapComponent.prototype.ngOnChanges = function (changes) {
        return __awaiter(this, void 0, void 0, function () {
            var native, _i, _a, marker, _b, _c, _d, _e, marker, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        if (!changes.empty)
                            return [2 /*return*/];
                        native = this.elementRef.nativeElement;
                        changes.empty.currentValue ? native.classList.add('empty') : native.classList.remove('empty');
                        if (changes.empty.firstChange)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.mapLoaded$.toPromise()];
                    case 1:
                        _h.sent();
                        if (!changes.empty.currentValue) return [3 /*break*/, 3];
                        for (_i = 0, _a = this.markers; _i < _a.length; _i++) {
                            marker = _a[_i];
                            marker.setMap(null);
                        }
                        _c = (_b = this.map.data).setStyle;
                        return [4 /*yield*/, this.getMapStyle('empty')];
                    case 2:
                        _c.apply(_b, [_h.sent()]);
                        return [3 /*break*/, 5];
                    case 3:
                        for (_d = 0, _e = this.markers; _d < _e.length; _d++) {
                            marker = _e[_d];
                            marker.setMap(this.map);
                        }
                        _g = (_f = this.map.data).setStyle;
                        return [4 /*yield*/, this.getMapStyle('default')];
                    case 4:
                        _g.apply(_f, [_h.sent()]);
                        _h.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ProjectsMapComponent.prototype.getIconStyle = function () {
        return __awaiter(this, void 0, void 0, function () {
            var google, DEFAULT_ICON_STYLE;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.googleMapsService.promise];
                    case 1:
                        google = _a.sent();
                        DEFAULT_ICON_STYLE = {
                            path: google.maps.SymbolPath.CIRCLE,
                            scale: 8,
                            fillColor: 'white',
                            fillOpacity: 0.1,
                            strokeColor: 'white',
                            strokeOpacity: 1,
                            strokeWeight: 2
                        };
                        return [2 /*return*/, DEFAULT_ICON_STYLE];
                }
            });
        });
    };
    ProjectsMapComponent.prototype.getMapStyle = function (n) {
        return __awaiter(this, void 0, void 0, function () {
            var google, DEFAULT_MAP_STYLE, _a, EMPTY_MAP_STYLE, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.googleMapsService.promise];
                    case 1:
                        google = _c.sent();
                        _a = {};
                        return [4 /*yield*/, this.getIconStyle()];
                    case 2:
                        DEFAULT_MAP_STYLE = (_a.icon = _c.sent(),
                            _a.fillColor = 'white',
                            _a.fillOpacity = 0.1,
                            _a.strokeColor = 'white',
                            _a.strokeOpacity = 1,
                            _a.strokeWeight = 2,
                            _a);
                        _b = {};
                        return [4 /*yield*/, this.getIconStyle()];
                    case 3:
                        EMPTY_MAP_STYLE = (_b.icon = _c.sent(),
                            _b.fillColor = 'white',
                            _b.fillOpacity = 0,
                            _b.strokeColor = 'white',
                            _b.strokeOpacity = 0,
                            _b.strokeWeight = 2,
                            _b);
                        switch (n) {
                            case 'default': return [2 /*return*/, DEFAULT_MAP_STYLE];
                            case 'empty': return [2 /*return*/, EMPTY_MAP_STYLE];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ProjectsMapComponent.prototype.handleProjectionChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.hasBeenDragged)
                            return [2 /*return*/];
                        if (!this.paddings)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.itemsLoaded$.toPromise()];
                    case 1:
                        _a.sent();
                        this.recenter();
                        this.ui.widthResize$.subscribe(function (w) { return console.log('w', w); });
                        return [2 /*return*/];
                }
            });
        });
    };
    ProjectsMapComponent.prototype.recenter = function () {
        return __awaiter(this, void 0, void 0, function () {
            var projection, width, lat, ratio, totalWidth, leftBoundary, rightBoundary, x, xPx, yPx, visualCenterPointPx, visualCenterLatLng, currentCenterLatLng, centerLngDiff, newCenterLng, newCenter;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        projection = this.map.getProjection();
                        // projection.from
                        console.log(projection);
                        width = window.innerWidth;
                        lat = 51.25482464949703;
                        ratio = 0.5;
                        if (width >= 930) {
                            totalWidth = Math.max(width, 1280);
                            leftBoundary = this.paddings.left;
                            rightBoundary = totalWidth - this.paddings.right;
                            x = (leftBoundary + rightBoundary) / 2;
                            ratio = x / totalWidth;
                            console.log(ratio);
                        }
                        xPx = width * ratio;
                        yPx = window.innerHeight / 2;
                        visualCenterPointPx = new google.maps.Point(xPx, yPx);
                        return [4 /*yield*/, this.mapIdle$.toPromise()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.itemsLoaded$.toPromise()];
                    case 2:
                        _a.sent();
                        this.overlayView = new google.maps.OverlayView();
                        this.overlayView.draw = function () { };
                        this.overlayView.setMap(this.map);
                        visualCenterLatLng = this.overlayView.getProjection().fromContainerPixelToLatLng(visualCenterPointPx);
                        currentCenterLatLng = this.map.getCenter();
                        centerLngDiff = currentCenterLatLng.lng() - visualCenterLatLng.lng();
                        newCenterLng = currentCenterLatLng.lng() + centerLngDiff;
                        newCenter = new google.maps.LatLng(visualCenterLatLng.lat(), newCenterLng);
                        // debugger;
                        this.map.setCenter(newCenter);
                        return [2 /*return*/];
                }
            });
        });
    };
    return ProjectsMapComponent;
}());
export { ProjectsMapComponent };
//# sourceMappingURL=projects-map.component.js.map